// extracted by mini-css-extract-plugin
export default {"chat":"chat--KB5wQ","chat--open":"chat--open--PH1NQ","chatOpen":"chat--open--PH1NQ"};